<template>
  <div id="app">
    <!-- <div id="nav"> -->
      <!-- <router-link to="/">Home</router-link> | -->
      <!-- <router-link to="/about">About</router-link> | -->
      <!-- <router-link to="/pnote">Pnote</router-link> -->
    <!-- </div> -->
    <!-- <router-view/> -->
    <Pnote />
  </div>
</template>
<script>
import Pnote from "@/views/Pnote.vue";
export default {
  name: "app",
  components: {
    Pnote
  }
};
</script>
<style>
body {
  margin: 0;
}
html,body,#app{
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
